// Candidate CV upload card (advisor career-project detail → Oversikt tab).
// Lives in its own namespace so it can evolve independently of careerProject.js.
export const careerCvTranslations = {
  en: {
    title: "CV",
    dropzoneTitle: "Upload the candidate's CV (PDF, DOCX or TXT)",
    dropzoneHint: "Drag and drop the file here, or click to browse",
    helper: "The CV strengthens the competency analysis and makes the report more precise.",
    maxSize: "Max 10 MB.",
    uploading: "Uploading…",
    processing: "Reading the file…",
    uploadSuccess: "CV uploaded.",
    uploadFailed: "Could not upload the CV.",
    invalidType: "Invalid file type. Use PDF, DOCX or TXT.",
    tooLarge: "The file is too large (max 10 MB).",
    uploadedAt: "Uploaded {{date}}",
    extractedChars: "{{count}} characters extracted",
    extractFailed: "Could not read the text in the file — try a different file.",
    showPreview: "Show preview",
    hidePreview: "Hide preview",
    replace: "Replace",
    delete: "Delete",
    deleteTitle: "Delete the CV?",
    deleteBody: "The CV will be removed from the project and no longer used in the competency analysis or the report.",
    deleting: "Deleting…",
    deleteSuccess: "CV deleted.",
    deleteFailed: "Could not delete the CV.",
    cancel: "Cancel",
    loadFailed: "Could not load the CV status.",
    retry: "Try again"
  },
  nb: {
    title: "CV",
    dropzoneTitle: "Last opp kandidatens CV (PDF, DOCX eller TXT)",
    dropzoneHint: "Dra og slipp filen her, eller klikk for å velge",
    helper: "CV-en styrker kompetanseanalysen og gjør rapporten mer presis.",
    maxSize: "Maks 10 MB.",
    uploading: "Laster opp…",
    processing: "Leser filen…",
    uploadSuccess: "CV-en er lastet opp.",
    uploadFailed: "Kunne ikke laste opp CV-en.",
    invalidType: "Ugyldig filtype. Bruk PDF, DOCX eller TXT.",
    tooLarge: "Filen er for stor (maks 10 MB).",
    uploadedAt: "Lastet opp {{date}}",
    extractedChars: "{{count}} tegn hentet ut",
    extractFailed: "Kunne ikke lese teksten i filen — prøv en annen fil.",
    showPreview: "Vis forhåndsvisning",
    hidePreview: "Skjul forhåndsvisning",
    replace: "Erstatt",
    delete: "Slett",
    deleteTitle: "Slette CV-en?",
    deleteBody: "CV-en fjernes fra prosjektet og brukes ikke lenger i kompetanseanalysen eller rapporten.",
    deleting: "Sletter…",
    deleteSuccess: "CV-en er slettet.",
    deleteFailed: "Kunne ikke slette CV-en.",
    cancel: "Avbryt",
    loadFailed: "Kunne ikke laste CV-status.",
    retry: "Prøv igjen"
  }
};
